export function arrayIsDefinedAndContainsKey(array, key): boolean {
  return array && array[key] && array[key].length !== 0;
};

export function arrayInObjectIsEmpty(array, key): boolean {
  return array && array[key] && array[key].length === 0;
}

export function arrayIsDefinedAndEmpty(array): boolean {
  return array && array.length === 0;
}

export function arrayContainsValue(array, key, value): boolean {
  return array && array[key] && array[key].indexOf(value) !== -1;
}



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/shared/array-functions.ts